import { useRef, useState, useEffect } from "react";
import { invertColor, getAverageRGB } from "../helpers/colorHelpers";

export default function useImageColorDetection() {
  const imageWrapperRef = useRef();
  const [invertedColor, setInvertedColor] = useState(null);

  const detectImageColor = () => {
    // Get placeholder image
    const imageContainer = imageWrapperRef.current;
    if (!imageContainer) {
      console.log("Warning from color detection. No ref was given.");
      return;
    }

    const image = imageContainer.querySelectorAll("img")[0];
    if (!image) {
      console.log("Warning from color detection. Wrapper has no image.");
      return;
    }

    const rgb = getAverageRGB(image);
    const invertedColor = invertColor(rgb, true);

    setInvertedColor(invertedColor);
  };

  useEffect(() => {
    detectImageColor();
  }, []);

  return { imageWrapperRef, invertedColor, detectImageColor };
}
